import { render } from "./QRjump.vue?vue&type=template&id=36894bab"
import script from "./QRjump.vue?vue&type=script&lang=js"
export * from "./QRjump.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__